/* ── Small formatters, shared by the roster and its drawer ────────────────── */

export function relative(iso: string): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export const stamp = (iso: string): string =>
  new Date(iso).toLocaleDateString('en-PH', { dateStyle: 'medium' });

/**
 * "Ma. Angelica Cruz" → "AC".
 *
 * The design's rule is the first letter of the first two words longer than two
 * characters, counting letters only — which is what drops the "Ma." and keeps
 * the honorific out of the avatar.
 */
export function initials(name: string): string {
  const words = name
    .split(/\s+/)
    .map((w) => w.replace(/[^\p{L}]/gu, ''))
    .filter((w) => w.length > 2);
  const picked = words.slice(0, 2).map((w) => w.slice(0, 1));
  const joined = picked.join('');
  return (joined || name.replace(/[^\p{L}]/gu, '').slice(0, 2) || '?').toUpperCase();
}

/**
 * Risk banding.
 *
 * risk_score is stored; the BAND is ours — nothing in the schema defines where
 * Low ends. So the raw score is always printed next to the word, and the word
 * never appears alone.
 */
export const riskBand = (score: number): string =>
  score >= 70 ? 'High' : score >= 40 ? 'Medium' : 'Low';

/** "search" · "search and status filter" · "search, status filter and More filters" */
export function joinPhrases(items: readonly string[]): string {
  if (items.length <= 1) return items[0] ?? '';
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1] ?? ''}`;
}
